export default __webpack_public_path__ + "static/media/Expired_link.78ac7bff.svg";